module.exports = __webpack_public_path__ + "img/crotch_height.72ff3cdf.png";